module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-10-4cb28bbb7cb9ad01b3583497b239d6b8.jpg";